import { faker } from '@faker-js/faker';
import type {
  DeploymentRequestResourceReadV2Api,
  GetConfigurationByIdV2QueryResponseApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import {
  enumConfigurationResourceSoftwareItemV2,
  enumDeploymentRequestStatusV2,
} from '@ingenico/api-sdk-device-management-private-v2';

export function getConfigurationByIdV2InitialData(): GetConfigurationByIdV2QueryResponseApi {
  return {
    updatedBy: {
      id: faker.string.uuid(),
    },
    creationDate: faker.date.recent(),
    description: faker.lorem.sentence(),
    creator: {
      id: faker.string.uuid(),
      // name: faker.person.fullName(), // this change can be impacted due upgrade on MDMGT-7043
    },
    id: faker.string.uuid(),
    name: faker.lorem.word(),
    updateDate: faker.date.recent(),
    definition: {
      compositions: [],
      configuration: {
        applicationVersions: [
          {
            id: faker.string.uuid(),
            order: 0,
            type: faker.helpers.arrayElement(Object.values(enumConfigurationResourceSoftwareItemV2)),
            configurationModuleName: faker.lorem.word(),
            // softwareVersionNumber: '1.0.0', // this change can be impacted due upgrade on MDMGT-7043
          },
        ],
        osVersion: {
          id: faker.string.uuid(),
          // softwareName: faker.lorem.word() // this change can be impacted due upgrade on MDMGT-7043
          // softwareVersionNumber: '1.0.0', // this change can be impacted due upgrade on MDMGT-7043
        },
        remoteKeyInjection: [],
        systemPackageVersions: [],
      },
    },
  };
}

// eslint-disable-next-line max-lines-per-function
export function generateDeploymentRequestReadV2Api(): DeploymentRequestResourceReadV2Api {
  return {
    description: faker.lorem.sentence(),
    name: faker.string.alphanumeric(120),
    trigger: {
      scheduleOption: {
        date: faker.date.past(),
        exclusionDates: [faker.date.past()],
        timeSlot: {
          endDate: faker.date.future(),
          startDate: faker.date.past(),
        },
      },
      type: 'AUTOMATIC',
    },
    creationDate: faker.date.past(),
    id: faker.string.uuid(),
    status: faker.helpers.arrayElement(Object.values(enumDeploymentRequestStatusV2)),
    statusDetail: {
      errorCode: faker.string.uuid(),
      message: faker.commerce.product(),
      placeholders: [
        {
          key: faker.string.uuid(),
          value: faker.string.uuid(),
        },
      ],
    },
    creator: {
      id: faker.string.uuid(),
      name: faker.person.fullName(),
      type: 'AUTOMATOR',
    },
    dynamicGroup: {
      deviceCount: faker.number.int({ min: 0, max: 100 }),
      query: {
        filters: [
          {
            filterType: 'string',
            name: 'entity.attribute',
            operator: 'equals',
            value: faker.lorem.words(2),
          },
        ],
        sort: {
          field: 'entity.attribute',
          order: 'DESC',
        },
      },
      reference: {
        id: faker.string.uuid(),
      },
      snapshotId: faker.string.uuid(),
      type: 'CUSTOM',
    },
    options: {
      configuration: {
        custom: {
          definition: {
            compositions: [
              {
                configurationId: '6f76a660-5421-4a45-95a3-5916e09f99fc',
                name: faker.lorem.word(),
              },
            ],
            configuration: {
              applicationVersions: [
                {
                  id: 'fb3deb79-91a5-4204-ad69-5a52cd76bf5c',
                  order: 123,
                  type: 'CONFIGURATION_MODULE',
                  configurationModuleName: faker.lorem.word(),
                  // softwareVersionNumber: '1.0.0', // this change can be impacted due upgrade on MDMGT-7043
                },
              ],
              osVersion: {
                id: '6ece63c4-6bd4-4682-9102-7ec18bae014e',
                // softwareName: faker.lorem.word(), // this change can be impacted due upgrade on MDMGT-7043
                // softwareVersionNumber: '1.0.0', // this change can be impacted due upgrade on MDMGT-7043
              },
              remoteKeyInjection: ['d9b10975-f550-4213-aa1a-0173998c0b7c'],
              systemPackageVersions: [
                {
                  id: 'deb908cf-5a3d-4562-b29e-b53c20942666',
                  order: 123,
                  type: 'CONFIGURATION_MODULE',
                  configurationModuleName: faker.lorem.word(),
                  // softwareVersionNumber: '1.0.0', // this change can be impacted due upgrade on MDMGT-7043
                },
              ],
            },
          },
          updatedBy: {
            id: faker.string.uuid(),
          },
          description: 'Depraedor verecundia contigo sunt.',
          name: 'AE78ZHuvuAQORKLfy3gf46Cd7yC9mIbXjeREnCYUPZeMFXwd2nJhWTFcffTjLxBg5HL60mgnLvWmAgkGFH5AOF1rnX3ZY18FnNnQ',
          creationDate: new Date('2025-01-23T17:55:06.463Z'),
          creator: {
            id: '26f6a367-db70-48ce-9f35-626db834bd25',
            // name: 'Adrian', // this change can be impacted due upgrade on MDMGT-7043
          },
          id: '494fb341-1c46-4758-bbb8-e0e0ad6230c3',
          updateDate: new Date('2024-06-22T06:55:45.260Z'),
        },
        reference: {
          id: faker.string.uuid(),
        },
        snapshotId: faker.string.uuid(),
        type: 'CUSTOM',
      },
      delete: {
        applicationVersionsIds: [faker.string.uuid()],
        filePaths: [faker.system.filePath()],
        packageIds: [faker.string.alphanumeric(16)],
        systemPackageVersionsIds: [faker.string.uuid()],
      },
    },
  };
}
